/**
 * Escapes a string so that it can be used as a regex
 * @param text Text to escape
 * @returns Escaped text
 * @remarks
 * This is generally used from basic test filters: the text input by users is escaped by this function,
 * and then converted to a regex is is used as a filter
 */
export function escape(text: string): string {
    return text
        ? text.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
        : text
}
